'use client';

import { Fragment } from 'react';
import Link from 'next/link';
import styles from './BusinessModelCta.module.scss';
import { ArrowRight, Phone } from 'lucide-react';
import { gaCta } from '@/src/helpers/gtag';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface BusinessModelCtaProps {
  title?: string;
  highlightedTitle?: string;
  description?: string;
  primaryCta?: string;
  primaryHref?: string;
  secondaryCta?: string;
  secondaryHref?: string;
  backgroundImage?: string;
  tilt?: 'left' | 'right';
}

const renderTitle = (text: string) => {
  const parts = text.split('*');
  return parts.map((part, i) =>
    i % 2 === 1 ? <em key={i}>{part}</em> : <Fragment key={i}>{part}</Fragment>
  );
};

export function BusinessModelCta({
  title = 'Prêt à déléguer votre projet',
  highlightedTitle = '*sans perdre le contrôle* ?',
  description = 'Discutons de votre besoin. Nous vous répondons sous 24h avec une première approche et un plan de marche clair.',
  primaryCta = 'Prendre rendez-vous',
  primaryHref = '/contact',
  secondaryCta = 'Signer un NDA',
  secondaryHref = '/contact?topic=nda',
  tilt = 'left',
}: BusinessModelCtaProps) {
  const tiltClass = tilt === 'left' ? styles.tiltLeft : styles.tiltRight;
  useAOS();

  return (
    <div className={`${styles.root} ${tiltClass}`}>
      <div className={styles.content}>
        <h2 className={styles.title} data-aos="fade-up" data-aos-duration="700">
          {renderTitle(title)} <em>{renderTitle(highlightedTitle)}</em>
        </h2>
        <p
          className={styles.description}
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="100"
        >
          {description}
        </p>
        <div
          className={styles.ctaRow}
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="200"
        >
          <Link
            href={primaryHref}
            className={styles.btnPrimary}
            onClick={() => gaCta(primaryCta, 'business_cta_primary', primaryHref)}
          >
            <Phone size={16} aria-hidden="true" />
            {primaryCta}
          </Link>
          <Link
            href={secondaryHref}
            className={styles.btnSecondary}
            onClick={() => gaCta(secondaryCta, 'business_cta_secondary', secondaryHref)}
          >
            {secondaryCta}
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </div>
  );
}
